export type IMonitorWriter = {
  updateValue: (metricName: string, value: number) => Promise<void>;
  increment: (metricName: string) => Promise<void>;
};

class MonitorWriter implements IMonitorWriter {
  private writers: IMonitorWriter[] = [];

  updateValue = async (metricName: string, value: number): Promise<void> => {
    this.writers.forEach(async (writer) => await writer.updateValue(metricName, value));
  };

  increment = async (metricName: string): Promise<void> => {
    this.writers.forEach(async (writer) => await writer.increment(metricName));
  };

  setWriters = (newWriters: IMonitorWriter[]): void => {
    this.writers = newWriters;
  };
}

export default new MonitorWriter();



// WEBPACK FOOTER //
// ./packages/platform-utils/monitoring/writers/monitorWriter.ts